import styled from 'styled-components'
import {Link} from 'react-router-dom'
import {Page} from './../common/StyledComponents'
import startBg from './../../theme/img/start-bg.png'

export const PlayButton = styled(Link)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20%;
  height: 0;
  padding-bottom: 20%;
`

export const StartPage = styled(Page)`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url('${startBg}');
`
